<!-- House Bill of Lading Format -->
<div class="hbl-container">
  <div class="hbl-page" *ngFor="let invoice of invoices; let i = index">

    <!-- Header -->
    <div class="hbl-header">
      <div class="header-left">
        <div class="logo-circle">
          <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo"
            style="width: 100%; height: 100%; object-fit: contain;">
          <span *ngIf="!logoUrl" class="logo-text">SMJ</span>
        </div>
      </div>
      <div class="header-center">
        <h1>HOUSE BILL OF LADING</h1>
      </div>
      <div class="header-right"></div>
    </div>

    <!-- BL Number -->
    <div class="bl-number-row">
      <strong>BL NO. : {{ invoice.shipping_info?.bl_number || '--' }}</strong>
    </div>

    <!-- Main Info Table -->
    <table class="info-table">
      <tbody>
        <!-- Row 1: Shipper | Vessel Name & Voyage Number -->
        <tr>
          <td class="info-cell left-cell">
            Shipper :<br>
            <strong>{{ settings?.company }}</strong><br>
            <br>
            TEL: {{ settings?.telephone }} Fax: {{ settings?.fax }}<br>
            Email : {{ settings?.email_1 }}
          </td>
          <td class="info-cell right-cell">
            Vessel Name &amp; Voyage Number<br>
            <br>
            <strong>{{ invoice.ship?.name || '-' }}</strong><br>
            <strong>{{ invoice.ship?.voyage_no || '-' }}</strong>
          </td>
        </tr>

        <!-- Row 2: Consignee | Discharging Port & Arrival Port -->
        <tr>
          <td class="info-cell left-cell">
            CONSIGNEE (if "Order" state Notify Party) :<br>
            <strong>{{ invoice.order?.buyer_company_name }}</strong><br>
            {{ invoice.order?.buyer_street_address }}<br>
            {{ invoice.order?.buyer_city }},{{ invoice.order?.buyer_country }}<br>
            TEL :{{ invoice.order?.buyer_telephone_no }}<br>
            Email :{{ invoice.order?.buyer_email_address }}
          </td>
          <td class="info-cell right-cell">
            Discharging Port And Country<br>
            <strong>{{ invoice.order?.to_port }}, {{ invoice.order?.to_country }}</strong>
            <br><br><br>
            Arrival Port and Country<br>
            <strong>{{ invoice.ship?.sailing_port || '-' }}, Japan</strong>
          </td>
        </tr>

        <!-- Row 3: Notify Party | ETA & ETD -->
        <tr>
          <td class="info-cell left-cell notify-cell">
            Notify Party (without liability to carrier) :
          </td>
          <td class="info-cell right-cell">
            <br>
            ETA : {{ formatDate(invoice.ship?.arrival_date) }}<br>
            <br>
            ETD : {{ formatDate(invoice.ship?.sailing_date) }}
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Cargo Table -->
    <table class="cargo-table">
      <thead>
        <tr>
          <th class="col-marks">Marks And<br>Numbers</th>
          <th class="col-desc">Number and Kind of Packages, Freight units,<br>Description of Goods</th>
          <th class="col-meas">
            Measurements<br>
            <ng-container *ngIf="viewMode === 'merged' && invoice.vehicles">{{ getTotalM3(invoice) }}</ng-container>
            <ng-container *ngIf="viewMode !== 'merged' || !invoice.vehicles">{{ invoice.vehicle?.m3 || '-'
              }}</ng-container>
            CBM
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Individual mode -->
        <tr *ngIf="viewMode !== 'merged' || !invoice.vehicles">
          <td class="col-marks">{{ invoice.vehicle.car_no }}</td>
          <td class="col-desc">
            <p>1. Used Vehicle(s)</p>
            <p>{{ invoice.vehicle?.company_name }} {{ invoice.vehicle?.name }}</p>
            <p>Color : {{ invoice.vehicle?.color }}</p>
            <p>Reg Yr. : {{ invoice.vehicle?.registration_year }}</p>
            <p>{{ invoice.vehicle?.vin_no }}</p>
          </td>
          <td class="col-meas">
            <p>Gross Weight</p>
            <p>{{ invoice.vehicle?.g_weight || invoice.vehicle?.car_weight || '-' }} KGS</p>
          </td>
        </tr>

        <!-- Merged mode -->
        <ng-container *ngIf="viewMode === 'merged' && invoice.vehicles">
          <tr *ngFor="let vehicle of invoice.vehicles">
            <td class="col-marks">
              <div>{{ vehicle.vin_no }}</div>
            </td>
            <td class="col-desc">
              <p>1. Used Vehicle(s)</p>
              <p>{{ vehicle.company_name }} {{ vehicle.name }}</p>
              <p>Color : {{ vehicle.color }}</p>
              <p>Reg Yr. : {{ vehicle.registration_year }}</p>
              <p>{{ vehicle.vin_no }}</p>
            </td>
            <td class="col-meas">
              <p>Gross Weight</p>
              <p>{{ vehicle.g_weight || vehicle.car_weight || '-' }} KGS</p>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <!-- Footer -->
    <div class="hbl-footer">
      <div class="footer-note">
        <p><strong>*Please Note</strong></p>
        <p>*This is to confirm that this vehicle has been shipped</p>
        <p>*This document can't be used for any other purposes regarding permit application or any other port clearing
          Processes</p>
      </div>
      <div class="footer-stamp">
        <div class="stamp-box">
          <span>SUPREME<br>MOTORS</span>
        </div>
      </div>
    </div>

    <!-- Page Break -->
    <div class="page-break" *ngIf="i < invoices.length - 1"></div>

  </div>
</div>
